<template>
  <div class="apply-box">
    <template v-if="pageType">
      <div class="login-line">
        <div class="form-lable">姓名</div>
        <div class="form-input">
          <input
            type="text"
            class="input"
            maxlength="8"
            v-model="formData.userName"
            placeholder="请输入姓名"
          />
        </div>
      </div>
      <div class="login-line">
        <div class="form-lable">邮箱</div>
        <div class="form-input">
          <input
            type="text"
            class="input"
            maxlength="120"
            v-model="formData.email"
            placeholder="请输入邮箱"
          />
        </div>
      </div>
      <div class="login-line">
        <div class="form-lable">手机</div>
        <div class="form-input">
          <input
            type="text"
            class="input"
            maxlength="11"
            v-model="formData.mobile"
            placeholder="请输入手机号"
          />
        </div>
      </div>
      <div class="login-line" style="margin-bottom: 50px">
        <div class="form-lable">备注</div>
        <div class="form-input">
          <textarea
            rows="3"
            class="textarea"
            cols="20"
            maxlength="80"
            placeholder="请输入申请理由"
            v-model="formData.remark"
          ></textarea>
        </div>
      </div>
      <div class="apply-btn" @click="applyAuthority">立即申请</div>
    </template>
    <template v-else>
      <div class="error-icon">
        <i class="el-icon-check" v-if="retCode === 1000"></i>
        <i class="el-icon-close" v-else></i>
      </div>
      <div class="error-text">{{ errorText }}</div>
    </template>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formData: {},
      pageType: true,
      errorText: '',
      retCode: 1000
    }
  },
  methods: {
    applyAuthority () {
      const formData = this.formData
      const isEmall = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
      const isMobile = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      var msg = null
      switch (true) {
        case !formData.userName: msg = '请填写姓名!'; break
        case !isEmall.test(formData.email) : msg = '请填写正确的邮箱!'; break
        case !isMobile.test(formData.mobile) : msg = '请填写正确的手机号!'; break
      }
      if (msg) {
        this.$message.error(msg)
      } else {
        this.$service.applyAuthority(this.formData).then(res => {
          this.retCode = res.code
          this.pageType = false
          this.errorText = res.code === 1000 ? '您的申请提交成功,请等待审核！' : res.msg
        })
      }
    }
  },
  created () {
    this.pageType = true
    this.formData = this.$route.query
  }
}
</script>

<style lang="stylus" scoped>
.error-icon
  width 60px
  height 60px
  line-height 60px
  text-align center
  margin 0 auto
  font-size 40px
  border 2px solid #fc4c02
  border-radius 100%
  color #fc4c02
  margin-top 100px
.error-text
  text-align center
  font-size 16px
  color #666
  line-height 60px
.apply-box
  width 100vw
  height calc(100vh - 20px)
  background #eee
  padding-top 20px
.login-line
  line-height 35px
  background #fff
  width calc(100% - 40px)
  margin 0 auto
  display flex
  border-radius 5px
  margin-bottom 10px
  padding 5px 0
  .form-lable
    font-size 14px
    width 40px
    padding-left 15px
  .form-input
    flex 1
    padding-right 10px
    .input
      border 0 none
      padding 0
      height 25px
      line-height 25px
      padding 5px 0
      width 100%
      vertical-align top
      font-size 12px
    .textarea
      border 0 none
      padding 0
      line-height 17px
      margin 9px 0
      width 100%
      vertical-align top
      font-size 12px
      max-height 51px
.apply-btn
  height 45px
  line-height 45px
  width calc(100% - 40px)
  background #fc4c02
  margin 0 auto
  border-radius 5px
  text-align center
  font-size 14px
  color #fff
</style>
